// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.authStatus = 'loading'
  },
  auth_success (state, { token, user, username, rolesuser,rolesuserid,rolesid,permisos, vencimiento, foto, idestado,idsede, mensaje, idpersona }) {
    state.authStatus = 'success'
    state.token = token
    state.user = user
    state.username = username
    state.rolesuser = rolesuser
    state.rolesuserid = rolesuserid
    state.rolesid= rolesid
    state.permisos = permisos
    state.vencimiento = vencimiento
    state.foto = foto
    state.idestado = idestado
    state.idsede = idsede
    state.mensaje=mensaje
    state.idpersona=idpersona
  },
  auth_error (state, mensaje) {
    state.authStatus = 'error'
    state.token = ''
    state.user = ''
    state.username = ''
    state.rolesuser = null
    state.rolesuserid = null
    state.rolesid = null
    state.permisos = ''
    state.vencimiento = null
    state.foto = ''
    state.idestado = 0
    state.idsede = 0
    state.mensaje= mensaje
    state.idpersona=0
  },
  logout (state) {
    state.authStatus = ''
    state.token = ''
    state.user = ''
    state.username = ''
    state.rolesuser = null
    state.rolesuserid = null
    state.rolesid = null
    state.permisos = ''
    state.vencimiento = null
    state.foto = ''
    state.idestado = 0
    state.idsede = 0
    state.mensaje=''
    state.idpersona=0
  }
  ,setTableList (state, tableList) {
    state.tableList = tableList
  }
}
